const homePage = [
  {
    // 新增真实
    path: '/addRealAccount',
    name: 'addRealAccount',
    component: (resolve) => require(['@/views/index/addRealAccount/index'], resolve),
    meta: {
      isShow: true,
      isHide: true
    }
  },
  {
    // 新增模拟
    path: '/addFiktivAccount',
    name: 'addFiktivAccount',
    component: (resolve) => require(['@/views/index/addFiktivAccount/index'], resolve),
    meta: {
      isShow: true,
      isHide: true
    }
  },
  {
    // 绑定账号
    path: '/bindingId',
    name: 'bindingid',
    component: (resolve) => require(['@/views/index/bindingId/index'], resolve),
    meta: {
      isShow: true,
      isHide: true
    }
  },
  {
    // 账号主页
    path: '/idIndex',
    name: 'idindex',
    component: (resolve) => require(['@/views/index/idHome/index'], resolve),
    meta: {
      isShow: true,
      isHide: true
    }
  },
  {
    // 钱包
    path: '/wallet',
    name: 'wallet',
    component: (resolve) => require(['@/views/index/wallet/index'], resolve),
    meta: {
      isShow: true,
      isHide: true
    }
  }
]

export default homePage
